import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { Globals } from "src/app/globals";

@Component({
  selector: "app-entrada-fecha",
  templateUrl: "./entrada-fecha.component.html",
  styleUrls: ["./entrada-fecha.component.css"]
})
export class EntradaFechaComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() nombreControl: string;
  @Input() configCampo;
  @Input() valor;
  @Input() tipoFecha;

  checked = false;
  etiqueta;
  nombreCampo;
  control = new FormControl("", [Validators.required]);

  textonofinazado;

  constructor(public global: Globals) {}

  ngOnInit() {
    //////conole.log(this.tipoFecha);
    if (this.global.conflictosEditarConflicto) {
      let milisegundo = Date.parse(this.valor);
      if (!isNaN(milisegundo)) {
        let date = new Date(this.valor);
        this.control.setValue(date);
      } else if (this.valor) {
        this.checked = true;
        this.control.setValue(this.valor);
      } else {
        this.checked = true;
        this.control.setValue("No finalizado");
      }
    }

    this.parentForm.addControl(this.nombreControl, this.control);

    if (this.global.lenguaje == "es") {
      this.etiqueta = this.configCampo.es;
      this.nombreCampo = this.configCampo.es;
      this.textonofinazado = "No finalizado";
    } else {
      this.etiqueta = this.configCampo.en;
      this.nombreCampo = this.configCampo.en;
      this.textonofinazado = "It has not finished yet";
    }
  }

  noFinalizado() {
    if (this.checked) {
      this.control.setValue("No finalizado");
      this.control.setErrors(null);
    }
  }
}
